// In the one off chance that we decide to do SSR, we need to create the
// new query client inside of the react component so we don't leak data
// between different users and sessions. Leave this here in case I'm not here
// when the time comes to do SSR.

import { QueryClient } from "@tanstack/react-query";

// https://tanstack.com/query/latest/docs/framework/react/guides/ssr
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 5 * 60 * 1000,
    },
  },
});
